<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Seite erstellen') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.post(route('admin.pages.store'))">
                <form-fields 
                    :form="form"
                    :template-options="templateOptions" 
                    :publish-status-options="publishStatusOptions" 
                    />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'templateOptions',
            'publishStatusOptions',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    account_id: null,
                    title: null,
                    slug: null,
                    content: null,
                    meta_title: null,
                    meta_description: null,
                    meta_robots: null,
                    image_id: null,
                    template: null,
                    number_views: null,
                    publish_status: 'publish',
                    publish_from: null,
                    publish_until: null,
//                    visible_to_logged_in_users_only: false,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>